<template>
    <div class="frame">
        <section :class="{ 'isDateSelected': diaSeleccionado !== null }" class="calendarMoreInfo">

            <div @click="diaSeleccionado = null, selectedActivity = null" class="header">
                <button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                        <path d="M6 0.5L1 7.5L6 14.5" stroke="#464D5B" stroke-linecap="round" />
                    </svg>
                </button>

                <h5 v-if="selectedActivity?.feeling">Este día te sentiste</h5>
                <h5 v-else>Actividad diaria</h5>
                <span>{{ diaSeleccionado }}</span>
            </div>

            <div class="moodExpanded" v-if="selectedActivity?.feeling">
                <div class="mood">
                    <svg xmlns="http://www.w3.org/2000/svg" width="69" height="70" viewBox="0 0 69 70" fill="none">
                        <path
                            d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                            fill="#B359F8" />
                        <path
                            d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                            fill="#B359F8" />
                    </svg>
                    <img :src="emotionsOptions.find(item => item.value === selectedActivity?.feeling) ? emotionsOptions.find(item => item.value === selectedActivity?.feeling).image : emotionsOptions[3].image"
                        alt="">
                </div>
                <p>{{ selectedActivity?.feeling ? selectedActivity?.feeling : 'neutral' }}</p>
            </div>

            <h5>Terminaste con las siguientes clases</h5>
            <div class="contResumeClases">
                <template v-if="selectedActivity?.finishedClasses">
                    <div class="infoCard resumeClass" v-for="n in selectedActivity.finishedClasses">
                        <div>
                            <h6>{{ n.fitnessClass.title }}</h6>
                            <p>{{ n.fitnessClass.descr }}</p>
                            <hr>
                            <span>{{ n.fitnessClass.method }}</span>
                        </div>

                        <button>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M3.42857 0.5H11.1429C11.6162 0.5 12 0.883756 12 1.35714V9.07143C12 9.54482 11.6162 9.92857 11.1429 9.92857C10.6695 9.92857 10.2857 9.54482 10.2857 9.07143V3.42647L1.46323 12.2489C1.1285 12.5837 0.585786 12.5837 0.251051 12.2489C-0.0836838 11.9142 -0.0836838 11.3715 0.251051 11.0368L9.07353 2.21429H3.42857C2.95519 2.21429 2.57143 1.83053 2.57143 1.35714C2.57143 0.883756 2.95519 0.5 3.42857 0.5Z"
                                    fill="#B359F8" />
                            </svg>
                        </button>
                    </div>
                </template>

                <div class="infoCard resumeClass noClases" v-else>
                    <h5>No haz completado clases este dia.</h5>
                </div>

            </div>

            <template v-if="notaActual">
                <h5>Tu nota del día</h5>

                <VueEditor disabled="disabled" id="description" class="vue__editor" :editor-toolbar="customToolbar"
                    v-model="notaActual" />
            </template>

        </section>
        <section :class="{ 'hide': diaSeleccionado !== null }">
            <h4>Reporte Mensual</h4>
            <div class="infoCard">
                <div class="calendarCont">
                    <h5>{{ fechaSeleccionada.format('MMMM YYYY') }}</h5>
                    <div class="calendar">
                        <div class="calendarHead">
                            <div class="dayLabel">Dom</div>
                            <div class="dayLabel">Lun</div>
                            <div class="dayLabel">Mar</div>
                            <div class="dayLabel">Mie</div>
                            <div class="dayLabel">Jue</div>
                            <div class="dayLabel">Vie</div>
                            <div class="dayLabel">Sab</div>
                        </div>
                        <div class="dayCont">
                            <div class="day passed" v-for="n in diasPrevios.reverse()">
                                <p>{{ n }}</p>
                            </div>
                            <button :disabled="monthlyReportData.activity.every(item => item.day !== n)" class="day"
                                v-for="n in diasDelMes" @click="selectDay(n)"
                                :class="{ 'today': !mesCambiado && diaActual === n }">
                                <p>{{ n < 10 ? '0' + n : n }}</p>
                                        <div
                                            :class="{ 'gotInfo': monthlyReportData.activity.some(item => item.day === n) }">
                                        </div>
                            </button>
                            <div class="day passed" v-for="n in (-ultimoDiaDelMes + 6)">
                                <p>{{ n }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="changeMonth">
                    <button @click="retrocederMes(), getMontlyReport()" class="prevMonth">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                            <path d="M6 0.5L1 7.5L6 14.5" stroke="#464D5B" stroke-linecap="round" />
                        </svg>
                    </button>
                    <button @click="avanzarMes(), getMontlyReport()" :disabled="botonDesactivado" class="nextMonth">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                            <path d="M1 14.5L6 7.5L1 0.5" stroke="#464D5B" stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <div class="resetMonth">
                    <button @click="irMesActual(), getMontlyReport()" :disabled="botonDesactivado" class="prevMonth">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M11.0102 9L13.8673 5M13.8673 5L11.0102 1M13.8673 5H6.29589C3.53447 5 1.2959 7.23858 1.2959 10V10C1.2959 12.7614 3.53447 15 6.2959 15H13.8673"
                                stroke="#464D5B" stroke-width="1" stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
            </div>
            <div class="infoCard">
                <!-- Clases terminadas en el mes -->

                <div class="resumeStat">
                    <p>Clases terminadas en el mes</p>
                    <div class="resumeNumber">
                        <p>{{ monthlyReportData.finishedClasses }}</p>

                    </div>
                </div>
                <hr>
                <!-- Programas activos en el mes -->
                <div class="infoStat">
                    <button :disabled="monthlyReportData.activePrograms.length === 0" class="resumeStat"
                        @click="toggleInfoStat('programasActivosMes')">
                        <p>Programas activos en el mes</p>
                        <div class="resumeNumber">
                            <span>{{ monthlyReportData.activePrograms.length }}</span>
                            <button>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="7" viewBox="0 0 16 7"
                                    fill="none">
                                    <path d="M1 0.5L8 5.5L15 0.499999" stroke="#464D5B" stroke-linecap="round" />
                                </svg>
                            </button>
                        </div>

                    </button>
                    <div class="statMoreInfo" :class="{ 'isOpen': infoToggled === 'programasActivosMes' }">
                        <div class="claseInfo" v-for="(activo, index) in monthlyReportData.activePrograms">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                fill="none">
                                <path
                                    d="M7.5 0.5C8.47633 0.5 8.9645 1.19721 8.9645 2.59162C8.9645 3.21466 8.90532 3.94154 8.78698 4.77225L8.60947 5.92932C8.5503 6.43368 8.50592 6.7452 8.47633 6.86387L8.38757 7.44241L10.5178 5.75131C11.9083 4.62391 12.9142 4.06021 13.5355 4.06021C14.1568 4.06021 14.5858 4.29756 14.8225 4.77225C14.9408 4.95026 15 5.15794 15 5.39529C15 6.04799 14.6598 6.58203 13.9793 6.99738C13.3284 7.38307 12.4408 7.78359 11.3166 8.19895L9.31953 9L11.8047 9.97906C12.6923 10.3351 13.3432 10.6466 13.7574 10.9136C14.5858 11.3586 15 11.9223 15 12.6047C15 12.8124 14.8964 13.0942 14.6893 13.4503C14.5118 13.7766 14.1272 13.9398 13.5355 13.9398C12.9438 13.9398 11.9379 13.3761 10.5178 12.2487L8.38757 10.5576L8.47633 11.2251C8.47633 11.3735 8.52071 11.6702 8.60947 12.1152L8.87574 13.6728C8.93491 14.2661 8.9645 14.8595 8.9645 15.4529C8.9645 16.0166 8.83136 16.5061 8.56509 16.9215C8.3284 17.3072 7.97337 17.5 7.5 17.5C7.02663 17.5 6.65681 17.3072 6.39053 16.9215C6.15385 16.5061 6.0355 16.0017 6.0355 15.4084C6.0355 14.7853 6.09468 14.0585 6.21302 13.2277L6.39053 12.0707C6.4497 11.5663 6.49408 11.2548 6.52367 11.1361L6.61243 10.5576L4.48225 12.2487C3.09172 13.3761 2.0858 13.9398 1.4645 13.9398C0.843195 13.9398 0.414201 13.7024 0.177515 13.2277C0.0591716 13.0497 0 12.8421 0 12.6047C0 11.952 0.325444 11.4328 0.976331 11.0471C1.6568 10.6318 2.55917 10.2164 3.68343 9.80105L5.68047 9L3.19527 8.02094C2.33728 7.69459 1.6716 7.38307 1.19822 7.08639C0.399408 6.61169 0 6.04799 0 5.39529C0 5.18761 0.0887574 4.92059 0.266272 4.59424C0.473373 4.23822 0.798816 4.06021 1.2426 4.06021C1.71598 4.06021 2.18935 4.20855 2.66272 4.50523C3.13609 4.77225 3.7426 5.18761 4.48225 5.75131L6.61243 7.44241L6.52367 6.77487C6.52367 6.62653 6.47929 6.32984 6.39053 5.88482L6.12426 4.32723C6.06509 3.73386 6.0355 3.14049 6.0355 2.54712C6.0355 1.92408 6.15385 1.43455 6.39053 1.07853C6.65681 0.692845 7.02663 0.5 7.5 0.5Z"
                                    fill="url(#paint0_linear_1275_1490)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1275_1490" x1="15" y1="9" x2="0" y2="9"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE711" />
                                        <stop offset="1" stop-color="#96FF11" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <p>{{ activo.program.title }}</p>
                            <span>{{ activo.completedClasses }} / {{ activo.totalClasses }} clases</span>
                        </div>

                    </div>
                </div>
                <hr>
                <!-- Programas finalizados en el mes -->
                <div class="infoStat">
                    <button :disabled="monthlyReportData.finishedPrograms.length === 0" class="resumeStat"
                        @click="toggleInfoStat('programasFinalizadosMes')">
                        <p>Programas finalizados <br> en el mes</p>
                        <div class="resumeNumber">
                            <span>{{ monthlyReportData.finishedPrograms.length }}</span>
                            <button>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="7" viewBox="0 0 16 7"
                                    fill="none">
                                    <path d="M1 0.5L8 5.5L15 0.499999" stroke="#464D5B" stroke-linecap="round" />
                                </svg>
                            </button>
                        </div>
                    </button>
                    <div class="statMoreInfo" :class="{ 'isOpen': infoToggled === 'programasFinalizadosMes' }">
                        <div class="claseInfo" v-for="(finished, index) in monthlyReportData.finishedPrograms">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                fill="none">
                                <path
                                    d="M7.5 0.5C8.47633 0.5 8.9645 1.19721 8.9645 2.59162C8.9645 3.21466 8.90532 3.94154 8.78698 4.77225L8.60947 5.92932C8.5503 6.43368 8.50592 6.7452 8.47633 6.86387L8.38757 7.44241L10.5178 5.75131C11.9083 4.62391 12.9142 4.06021 13.5355 4.06021C14.1568 4.06021 14.5858 4.29756 14.8225 4.77225C14.9408 4.95026 15 5.15794 15 5.39529C15 6.04799 14.6598 6.58203 13.9793 6.99738C13.3284 7.38307 12.4408 7.78359 11.3166 8.19895L9.31953 9L11.8047 9.97906C12.6923 10.3351 13.3432 10.6466 13.7574 10.9136C14.5858 11.3586 15 11.9223 15 12.6047C15 12.8124 14.8964 13.0942 14.6893 13.4503C14.5118 13.7766 14.1272 13.9398 13.5355 13.9398C12.9438 13.9398 11.9379 13.3761 10.5178 12.2487L8.38757 10.5576L8.47633 11.2251C8.47633 11.3735 8.52071 11.6702 8.60947 12.1152L8.87574 13.6728C8.93491 14.2661 8.9645 14.8595 8.9645 15.4529C8.9645 16.0166 8.83136 16.5061 8.56509 16.9215C8.3284 17.3072 7.97337 17.5 7.5 17.5C7.02663 17.5 6.65681 17.3072 6.39053 16.9215C6.15385 16.5061 6.0355 16.0017 6.0355 15.4084C6.0355 14.7853 6.09468 14.0585 6.21302 13.2277L6.39053 12.0707C6.4497 11.5663 6.49408 11.2548 6.52367 11.1361L6.61243 10.5576L4.48225 12.2487C3.09172 13.3761 2.0858 13.9398 1.4645 13.9398C0.843195 13.9398 0.414201 13.7024 0.177515 13.2277C0.0591716 13.0497 0 12.8421 0 12.6047C0 11.952 0.325444 11.4328 0.976331 11.0471C1.6568 10.6318 2.55917 10.2164 3.68343 9.80105L5.68047 9L3.19527 8.02094C2.33728 7.69459 1.6716 7.38307 1.19822 7.08639C0.399408 6.61169 0 6.04799 0 5.39529C0 5.18761 0.0887574 4.92059 0.266272 4.59424C0.473373 4.23822 0.798816 4.06021 1.2426 4.06021C1.71598 4.06021 2.18935 4.20855 2.66272 4.50523C3.13609 4.77225 3.7426 5.18761 4.48225 5.75131L6.61243 7.44241L6.52367 6.77487C6.52367 6.62653 6.47929 6.32984 6.39053 5.88482L6.12426 4.32723C6.06509 3.73386 6.0355 3.14049 6.0355 2.54712C6.0355 1.92408 6.15385 1.43455 6.39053 1.07853C6.65681 0.692845 7.02663 0.5 7.5 0.5Z"
                                    fill="url(#paint0_linear_1275_1490)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1275_1490" x1="15" y1="9" x2="0" y2="9"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE711" />
                                        <stop offset="1" stop-color="#96FF11" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <p>{{ finished.program.title }}</p>
                            <img src="../../assets/HumanaProgramas/Vector.png" alt="">
                        </div>
                    </div>
                </div>
                <hr>
                <!-- Programas iniciados en el mes -->
                <div class="infoStat">
                    <button :disabled="monthlyReportData.startedPrograms.length === 0" class="resumeStat"
                        @click="toggleInfoStat('programasIniciadosMes')">
                        <p>Programas iniciados <br>
                            en el mes</p>
                        <div class="resumeNumber">
                            <span>{{ monthlyReportData.startedPrograms.length }}</span>
                            <button>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="7" viewBox="0 0 16 7"
                                    fill="none">
                                    <path d="M1 0.5L8 5.5L15 0.499999" stroke="#464D5B" stroke-linecap="round" />
                                </svg>
                            </button>
                        </div>
                    </button>

                    <div class="statMoreInfo" :class="{ 'isOpen': infoToggled === 'programasIniciadosMes' }">
                        <div class="claseInfo" v-for="(started, index) in monthlyReportData.startedPrograms">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                fill="none">
                                <path
                                    d="M7.5 0.5C8.47633 0.5 8.9645 1.19721 8.9645 2.59162C8.9645 3.21466 8.90532 3.94154 8.78698 4.77225L8.60947 5.92932C8.5503 6.43368 8.50592 6.7452 8.47633 6.86387L8.38757 7.44241L10.5178 5.75131C11.9083 4.62391 12.9142 4.06021 13.5355 4.06021C14.1568 4.06021 14.5858 4.29756 14.8225 4.77225C14.9408 4.95026 15 5.15794 15 5.39529C15 6.04799 14.6598 6.58203 13.9793 6.99738C13.3284 7.38307 12.4408 7.78359 11.3166 8.19895L9.31953 9L11.8047 9.97906C12.6923 10.3351 13.3432 10.6466 13.7574 10.9136C14.5858 11.3586 15 11.9223 15 12.6047C15 12.8124 14.8964 13.0942 14.6893 13.4503C14.5118 13.7766 14.1272 13.9398 13.5355 13.9398C12.9438 13.9398 11.9379 13.3761 10.5178 12.2487L8.38757 10.5576L8.47633 11.2251C8.47633 11.3735 8.52071 11.6702 8.60947 12.1152L8.87574 13.6728C8.93491 14.2661 8.9645 14.8595 8.9645 15.4529C8.9645 16.0166 8.83136 16.5061 8.56509 16.9215C8.3284 17.3072 7.97337 17.5 7.5 17.5C7.02663 17.5 6.65681 17.3072 6.39053 16.9215C6.15385 16.5061 6.0355 16.0017 6.0355 15.4084C6.0355 14.7853 6.09468 14.0585 6.21302 13.2277L6.39053 12.0707C6.4497 11.5663 6.49408 11.2548 6.52367 11.1361L6.61243 10.5576L4.48225 12.2487C3.09172 13.3761 2.0858 13.9398 1.4645 13.9398C0.843195 13.9398 0.414201 13.7024 0.177515 13.2277C0.0591716 13.0497 0 12.8421 0 12.6047C0 11.952 0.325444 11.4328 0.976331 11.0471C1.6568 10.6318 2.55917 10.2164 3.68343 9.80105L5.68047 9L3.19527 8.02094C2.33728 7.69459 1.6716 7.38307 1.19822 7.08639C0.399408 6.61169 0 6.04799 0 5.39529C0 5.18761 0.0887574 4.92059 0.266272 4.59424C0.473373 4.23822 0.798816 4.06021 1.2426 4.06021C1.71598 4.06021 2.18935 4.20855 2.66272 4.50523C3.13609 4.77225 3.7426 5.18761 4.48225 5.75131L6.61243 7.44241L6.52367 6.77487C6.52367 6.62653 6.47929 6.32984 6.39053 5.88482L6.12426 4.32723C6.06509 3.73386 6.0355 3.14049 6.0355 2.54712C6.0355 1.92408 6.15385 1.43455 6.39053 1.07853C6.65681 0.692845 7.02663 0.5 7.5 0.5Z"
                                    fill="url(#paint0_linear_1275_1490)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1275_1490" x1="15" y1="9" x2="0" y2="9"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE711" />
                                        <stop offset="1" stop-color="#96FF11" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <p>{{ started.program.title }}</p>
                            <span>{{ started.completedClasses }} / {{ started.totalClasses }} clases</span>
                        </div>
                    </div>
                </div>
                <hr>
                <!-- Mood promedio del mes -->
                <div class="resumeStat" v-if="monthlyReportData.mostFrequentFeeling">
                    <p>Tu humor dominante <br>
                        del mes</p>
                    <div class="infoCard emotions">
                        <div class="emotion">
                            <img :src="emotionsOptions.find(emotion => emotion.value === monthlyReportData.mostFrequentFeeling).image"
                                :alt="monthlyReportData.mostFrequentFeeling">
                            <svg xmlns="http://www.w3.org/2000/svg" width="69" height="70" viewBox="0 0 69 70"
                                fill="none">
                                <path
                                    d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                    fill="url(#paint0_linear_1581_6513)" />
                                <path
                                    d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                    fill="url(#paint1_linear_1581_6513)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1581_6513" x1="0" y1="35" x2="69" y2="35"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE711" />
                                        <stop offset="1" stop-color="#96FF11" />
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_1581_6513" x1="0" y1="35" x2="69" y2="35"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE711" />
                                        <stop offset="1" stop-color="#96FF11" />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <p>{{ monthlyReportData.mostFrequentFeeling }}</p>
                    </div>
                </div>
            </div>

        </section>

    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import dayjs from "dayjs";
import 'dayjs/locale/es'; // Importar el idioma español
import { mapActions } from "vuex";

dayjs.locale('es');

export default {
    name: "App",
    data() {
        return {
            fechaSeleccionada: dayjs(),
            infoToggled: null, // Fecha base que se puede modificar
            mesCambiado: false,
            botonDesactivado: true,
            diaSeleccionado: null,
            customToolbar: [
                [],
            ],
            items: 6,
            selectedActivity: null,
            notaActual: '',
            emotionsOptions: [
                {
                    value: 'happy',
                    image: require('../../assets/svg/moods/happy_active.svg'),
                },
                {
                    value: 'excited',
                    image: require('../../assets/svg/moods/excited_active.svg'),
                },
                {
                    value: 'confident',
                    image: require('../../assets/svg/moods/confident_active.svg'),
                },
                {
                    value: 'neutral',
                    image: require('../../assets/svg/moods/indifferent_active.svg'),
                },
                {
                    value: 'sad',
                    image: require('../../assets/svg/moods/sad_active.svg'),
                },
                {
                    value: 'angry',
                    image: require('../../assets/svg/moods/angry_active.svg'),
                },
                {
                    value: 'tired',
                    image: require('../../assets/svg/moods/tired_active.svg'),
                },
            ]
        };
    },
    components: {
        VueEditor
    },

    mounted() {
        this.getMontlyReport()
    },
    computed: {
        // Número de días del mes basado en la fecha seleccionada
        diasDelMes() {
            return this.fechaSeleccionada.daysInMonth();
        },
        // Número de días del mes anterior al seleccionado
        diasDelMesAnterior() {
            return this.fechaSeleccionada.subtract(1, 'month').daysInMonth();
        },
        // Día actual basado en la fecha seleccionada
        diaActual() {
            return this.fechaSeleccionada.date();
        },
        // Primer día del mes (número, 0 para domingo, 1 para lunes, etc.)
        primerDiaDelMes() {
            return this.fechaSeleccionada.startOf('month').day();
        },
        ultimoDiaDelMes() {
            return this.fechaSeleccionada.endOf('month').day();
        },

        diasPrevios() {
            const totalDiasAnterior = this.fechaSeleccionada.subtract(1, 'month').daysInMonth();
            return Array.from({ length: this.primerDiaDelMes }, (_, i) => totalDiasAnterior - i);
        },

        monthlyReportData() {
            const data = this.$store.getters['weekPlan/data'];
            return data;
        }
    },
    methods: {
        ...mapActions('weekPlan', ['getAllInfoWkp']),
        retrocederMes() {
            const nuevaFecha = this.fechaSeleccionada.subtract(1, 'month'); // Restar un mes
            this.cambiarFecha(nuevaFecha.format('YYYY-MM-DD')); // Formatear y pasar al método cambiarFecha
        },
        irMesActual() {
            const fechaActual = dayjs(); // Obtener la fecha actual
            this.cambiarFecha(fechaActual.format('YYYY-MM-DD')); // Cambiar la fecha seleccionada al mes actual
        },
        avanzarMes() {
            const nuevaFecha = this.fechaSeleccionada.add(1, 'month'); // Sumar un mes
            this.cambiarFecha(nuevaFecha.format('YYYY-MM-DD')); // Formatear y pasar al método cambiarFecha
        },
        cambiarFecha(nuevaFecha) {
            const nuevaFechaDayjs = dayjs(nuevaFecha); // Convertir la nueva fecha con dayjs
            const mesActual = dayjs().month(); // Mes actual (0-11)
            const añoActual = dayjs().year(); // Año actual

            this.fechaSeleccionada = nuevaFechaDayjs; // Actualizar la fecha seleccionada
            this.mesCambiado = nuevaFechaDayjs.month() !== mesActual || nuevaFechaDayjs.year() !== añoActual; // Comparar mes y año

            // Desactivar el botón si la nueva fecha está en el mes actual
            this.botonDesactivado = nuevaFechaDayjs.month() === mesActual && nuevaFechaDayjs.year() === añoActual;
        },
        toggleInfoStat(stat) {
            if (this.infoToggled === stat) {
                this.infoToggled = null;
            } else {
                this.infoToggled = stat;
            }
        },
        selectDay(dia) {
            // Crear una nueva fecha con el día seleccionado y el mes/año actuales
            const diaElegido = this.fechaSeleccionada.date(dia);

            // Actualizar el día seleccionado
            this.diaSeleccionado = diaElegido.format('DD / MM / YYYY');
            this.selectedActivity = this.monthlyReportData.activity.find(item => item.day === dia);
            this.notaActual = this.selectedActivity ? this.selectedActivity.note : '';
        },

        async getMontlyReport() {
            const fecha = dayjs(this.fechaSeleccionada);
            const month = fecha.month()
            const year = fecha.year()

            await this.getAllInfoWkp(`monthly-report?month=${month + 1}&year=${year}`);
        },
    }
};
</script>

<style scoped>
.infoStat button[disabled] {
    cursor: not-allowed;
}

button[disabled] {
    cursor: not-allowed;
    opacity: 0.3;
}

h4 {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 2.777778vw;
    font-style: normal;
    font-weight: 400;
    line-height: 2.777778vw;
}

h4 span {
    font-size: 1.111111vw;
    color: #b3b7be;
}

h5 {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.736111vw;
    font-style: normal;
    font-weight: 400;
    line-height: 2.777778vw;
}

section {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    gap: 2.083333vw;
    min-height: 71.597222vw;
    opacity: 1;
    transform: scale(1);
    transition: all 300ms ease;
}

.hide {
    opacity: 0;
    transform: scale(0.85);

}

.frame {
    overflow: hidden;
    width: 56.180556vw;
    position: relative;
}

.infoCard {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: .694444vw;
    padding: 1.041667vw;
    align-self: stretch;
    border-radius: 2.083333vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    background: var(--White, #FFF);
    position: relative;
}

.infoCard .infoCard {
    border-radius: 1.041667vw;
}

.changeMonth {
    display: flex;
    flex-direction: row;
    width: 50%;
    justify-content: space-between;
    position: absolute;
    left: 25%;
    top: 1.041667vw;
}

.changeMonth button {
    width: 2.430556vw;
    height: 2.430556vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.777778vw;
    border: #e6e6e6 solid .069444vw;
    transition: all 300ms ease;

}

.changeMonth button:hover {
    border: #4536EF solid .069444vw;
}

.changeMonth button:disabled {
    opacity: 0.3;
    cursor: auto;
}

.changeMonth button svg {
    width: .486111vw;
    height: 1.666667vw;
}

.resetMonth {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
    right: 1.041667vw;
    top: 1.041667vw;
}

.resetMonth button {
    width: 2.430556vw;
    height: 2.430556vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.777778vw;
    border: #e6e6e6 solid .069444vw;
    transition: all 300ms ease;

}

.resetMonth button:hover {
    border: #4536EF solid .069444vw;
}

.resetMonth button:disabled {
    opacity: 0.3;
    cursor: auto;
}

.resetMonth button svg {
    width: 1.111111vw;
    height: 1.111111vw;
    transform: translateY(-0.138889vw);

}


.calendarCont {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.041667vw;
    align-self: center;
}

.calendarCont h5 {
    color: #464D5B;
    text-align: center;
    font-family: Manrope;
    font-size: 1.736111vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
}

.calendar {
    width: 27.708333vw;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: .694444vw;
    padding: 1.041667vw;
    align-self: stretch;
    border-radius: 1.041667vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    background: var(--White, #FFF);
}

.calendarHead {
    display: flex;
    flex-direction: row;
    gap: .590278vw;
}

.dayLabel {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    height: 1.111111vw;
    width: 3.125vw;
}

.dayCont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: .590278vw;
}

.day {
    height: 3.125vw;
    width: 3.125vw;
    border-radius: 2.083333vw;
    border: .069444vw solid var(--Text, #464D5B);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
}

.gotInfo {
    height: .902778vw;
    width: .902778vw;
    border-radius: 1.388889vw;
    background: linear-gradient(270deg, #FFE711 0%, #96FF11 100%);
    position: absolute;
    top: 0;
    right: 0;
}

.day p {
    color: #464D5B;
    text-align: center;
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.today.day {
    background-color: #B359F8;
    border-color: #B359F8;
}

.today.day p {
    color: #FFF;

}

.passed {
    filter: grayscale(1) opacity(0.3);
    border: 0;
    pointer-events: none;
    user-select: none;
}

.resumeStat {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    cursor: pointer;
}

.resumeStat>p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.resumeNumber {
    width: 30.069444vw;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: .208333vw;
    position: relative;
    border-radius: 20.833333vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
}

.resumeNumber>p {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: 1.736111vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.resumeNumber>span {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.resumeNumber button {
    height: 2.083333vw;
    width: 2.083333vw;
    position: absolute;
    right: .486111vw;
    border-radius: 1.041667vw;
}

button[disabled] .resumeNumber button {
    cursor: not-allowed;
}

hr {
    border: 0;
    background: #E3E3E9;
    min-height: .069444vw;
    width: 100%;
}

.resumeStat .infoCard {
    width: 30.069444vw;
}

.emotion {
    width: 4.791667vw;
    height: 4.791667vw;
    display: flex;
    align-items: center;
    justify-content: center;
}

.emotion:hover svg {
    rotate: 180deg;
}

.emotion svg {
    width: 4.791667vw;
    height: 4.791667vw;
    position: absolute;
    z-index: 1;
    transition: all 800ms ease;
    rotate: 0deg;

}

.emotion img {
    position: relative;
    z-index: 2;
    filter: brightness(10);
}

.emotions {
    align-items: center
}

.emotions p {
    color: var(--purple, #B359F8);
    text-align: center;
    font-family: "SharpGrotesk-Medium25";
    font-size: .694444vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
}

.infoStat {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0vw;
    transition: all 300ms ease;
}

.infoStat:has(.isOpen) {
    gap: 1.041667vw;
}

.statMoreInfo {
    height: 0;
    overflow: clip;
    transition: all 300ms ease;
    display: flex;
    flex-direction: column;
    gap: .625vw;
    opacity: 0;
    transform: translateY(-2.083333vw);
    min-height: 0vw;
}

.statMoreInfo::-webkit-scrollbar {
    -webkit-appearance: none;
}

.statMoreInfo::-webkit-scrollbar:vertical {
    width: .367222vw;
    background-color: #e4e4e4;
    border-radius: 1.0416666666666665VW;
}

.statMoreInfo::-webkit-scrollbar-button:increment,
.statMoreInfo::-webkit-scrollbar-button {
    display: none;
}

.statMoreInfo::-webkit-scrollbar:horizontal {
    height: .364583vw;
}

.statMoreInfo::-webkit-scrollbar-thumb {
    background-color: #946dffb7;
    border-radius: 1.0416666666666665VW;
}

.statMoreInfo::-webkit-scrollbar-track {
    border-radius: .364583vw;
}

.isOpen {
    transform: translateY(0vw);
    opacity: 1;
    min-height: 3.611111vw;
    overflow-y: scroll;


}

.claseInfo {
    display: flex;
    flex-direction: row;
    gap: .625vw;
    align-items: center;
}

.claseInfo svg {
    width: 1.041667vw;
    height: 1.180556vw;
}

.claseInfo p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    min-width: 12.5vw;
}

.claseInfo span {
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.claseInfo img {
    width: 2.766389vw;
    height: 2.766389vw;
    object-fit: contain;
    object-position: center;
}

.moodExpanded {
    width: 100%;
    padding: .694444vw 2.777778vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2.083333vw;
    border-radius: 6.944444vw 0 0 6.944444vw;
    background: linear-gradient(270deg, #FFE711 0%, #96FF11 75%);
    background-size: 200%;
    background-position: 0 0;
    animation: bgMovement 3s ease infinite alternate;
}

@keyframes bgMovement {
    0% {
        background-position: 0 0;

    }

    100% {
        background-position: 100% 0;

    }
}

.moodExpanded p {
    color: var(--purple, var(--purple, #B359F8));
    font-family: Manrope;
    font-size: 2.777778vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
}

.mood {
    height: 4.861111vw;
    width: 4.861111vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

}



.mood:hover svg {
    rotate: 180deg;
}

.mood svg {
    position: absolute;
    left: 0;
    top: 0;
    height: 4.861111vw;
    width: 4.861111vw;
    z-index: 1;
    transition: all 1s ease
}

.mood img {
    width: 2.569444vw;
    height: 2.569444vw;
    z-index: 2;
    filter: brightness(10)
}

.calendarMoreInfo {
    background-color: #FFF;
    position: absolute;
    z-index: 2;
    right: -62.708333vw;

    width: 56.145833vw !important;
    min-height: 71.597222vw;
    height: auto;
    transition: all 300ms ease;
}

.isDateSelected {
    right: 0vw;
}

.header {
    display: flex;
    flex-direction: row;
    gap: .277778vw;
    align-items: center;
}

.header button {
    width: 1.736111vw;
    height: 1.736111vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.777778vw;
    transition: all 300ms ease;
}

.header button svg {
    width: .486111vw;
    height: 1.666667vw;
}

.header span {
    text-align: center;
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: auto;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding: .694444vw 1.458333vw;

    border-radius: 20.833333vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
}

.contResumeClases {
    display: flex;
    flex-direction: column;
    gap: 1.041667vw;
    overflow-y: auto;
    max-height: 37.708333vw;
}

.contResumeClases::-webkit-scrollbar {
    -webkit-appearance: none;
}

.contResumeClases::-webkit-scrollbar:vertical {
    width: .364583vw;
    background-color: #e4e4e4;
    border-radius: 1.0416666666666665VW;
}

.contResumeClases::-webkit-scrollbar-button:increment,
.contResumeClases::-webkit-scrollbar-button {
    display: none;
}

.contResumeClases::-webkit-scrollbar:horizontal {
    height: .364583vw;
}

.contResumeClases::-webkit-scrollbar-thumb {
    background-color: #946dffb7;
    border-radius: 1.0416666666666665VW;
}

.contResumeClases::-webkit-scrollbar-track {
    border-radius: .364583vw;
}


.resumeClass {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center
}

.noClases {
    justify-content: center;
}

.noClases h5 {
    color: #a1a3a7;
    font-family: Manrope;
    font-size: 1.388889vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.resumeClass h6 {
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}



.resumeClass p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.resumeClass span {
    font-family: "SharpGrotesk-Medium25";
    font-size: .625vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.resumeClass>div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: .694444vw;
}

.resumeClass button {
    display: flex;
    width: 2.777778vw;
    height: 2.777778vw;
    justify-content: center;
    align-items: center;
    gap: .694444vw;

    border-radius: 20.833333vw;
    border: .069444vw solid #979797;
}

.resumeClass button svg {
    width: .833333vw;
    height: .833333vw;
}

/* VueEditorStyles */

.vue__editor {
    width: 100%;
    border-color: #E3E3E9;
    border: .069444vw solid #E3E3E9;
    border-radius: 2.083333vw;
}

.vue__editor>>>.ql-toolbar.ql-snow {
    padding-top: .277778vw !important;
    padding-bottom: .277778vw !important;
    height: 2.777778vw !important;
    border-color: #DBDBDB;
    display: none;
}

.vue__editor>>>.quillWrapper .ql-snow.ql-toolbar .ql-formats {
    margin-bottom: 0 !important;
}

.vue__editor>>>.ql-toolbar.ql-snow .ql-formats {
    margin-right: 0 !important;
}

.vue__editor>>>.ql-toolbar.ql-snow+.ql-container.ql-snow {
    border-color: #fff;
    border: .069444vw solid #fff;
    border-radius: 2.083333vw;
}

.vue__editor>>>.ql-editor {
    min-height: unset !important;
    height: 8.194444vw;
    color: #323232 !important;
    font-family: "DM Sans" !important;

    font-size: .833333vw !important;
    line-height: normal !important;
    padding: 1.041667vw !important;

}

.vue__editor>>>.ql-editor.ql-blank::before {
    font-weight: 300 !important;
}

@media (max-width: 530px) {
    .frame {
        width: 100%;
    }

    .calendarMoreInfo {
        width: 100% !important;
        right: -100%;
        height: 100%;
    }

    .isDateSelected {
        right: 0;
    }

    .calendar {
        width: 93.023256vw;
        padding: 3.488372vw;
        gap: 2.325581vw;
        border: 0;
        background-color: transparent;
    }

    .dayCont {
        justify-content: center;
        gap: 2.093023vw;
    }

    .day {
        height: 10.465116vw;
        width: 10.465116vw;
        border-radius: 11.627907vw;
    }

    .day p {
        font-size: 3.488372vw;
    }

    .calendarHead {
        gap: 2.093023vw;
    }

    .dayLabel {
        width: 10.465116vw;
        height: 3.72093vw;
        font-size: 2.790698vw;
    }

    .gotInfo {
        height: 2.790698vw;
        width: 2.790698vw;
    }

    h4 {
        display: none;
    }

    .calendarCont h5 {
        font-size: 5.813953vw;
    }

    .changeMonth {
        width: 75%;
        left: 12.5%;
        top: 2.325581vw;
    }

    .changeMonth button {
        width: 10.465116vw;
        height: 10.465116vw;
        border-radius: 10.465116vw;
    }

    .changeMonth button svg {
        width: 3.486111vw;
        height: 3.666667vw;
    }

    .calendarCont {
        gap: 2.325581vw;
    }

    .infoCard {
        padding: 3.488372vw;
        gap: 3.488372vw;
        border-radius: 6.976744vw;
    }

    .resetMonth {
        right: 2.041667vw;
        top: 4.041667vw;
    }

    .resetMonth button {
        height: 7vw;
        width: 7vw;
        border-radius: 3.488372vw;
    }

    .resetMonth button svg {
        width: 3.611111vw;
        height: 3.611111vw;
        transform: translateY(-0.138889vw);
    }

    .resumeStat>p {
        font-size: 3.488372vw;
    }

    .resumeNumber {
        padding: .930233vw 2.325581vw;
    }

    .resumeNumber>p {
        font-size: 5.813953vw;
    }

    .resumeNumber>span {
        font-size: 4.186047vw;
    }

    .resumeNumber button {
        height: 8.139535vw;
        width: 8.139535vw;
        right: 1vw;
        top: 0;
    }

    hr {
        display: block;
    }

    .isOpen {
        min-height: 18.604651vw;
    }

    .claseInfo {
        gap: 2.325581vw;
    }

    .claseInfo p {
        font-size: 3.72093vw;
    }

    .claseInfo span {
        font-size: 3.72093vw;
    }

    .claseInfo svg {
        width: 3.488372vw;
        height: 3.488372vw;
    }

    .statMoreInfo {
        gap: 2.325581vw;
    }

    .emotion svg {
        height: 13.953488vw;
        width: 13.953488vw;
    }

    .resumeStat .infoCard {
        height: 23.255814vw;
        gap: 3.488372vw;
        border-radius: 3.488372vw;
    }

    .emotion {
        width: 34.977713vw;
        height: 34.977713vw;
    }

    .emotions p {
        font-size: 2.790698vw;
    }

    .calendarMoreInfo {
        gap: 3.488372vw;
    }

    h5 {
        font-size: 5.813953vw;
        line-height: 6.511628vw;
        text-wrap: balance;
    }

    .header {
        gap: 3.488372vw;
    }

    .header button svg {
        width: 2.486111vw;
        height: 4.666667vw;
    }

    .header span {
        padding: 1.860465vw 2.790698vw;
        font-size: 2.790698vw;
    }

    .moodExpanded {
        padding: 2.325581vw 9.302326vw;
        border-radius: 69.767442vw;
        gap: 6.976744vw;
    }

    .moodExpanded p {
        font-size: 9.302326vw;
    }

    .mood {
        height: 14.861111vw;
        width: 14.861111vw;
    }

    .mood svg {
        height: 14.861111vw;
        width: 14.861111vw;
    }

    .mood img {
        width: 7.569444vw;
        height: 7.569444vw;
    }

    .resumeClass>div {
        gap: 2.325581vw;
    }

    .resumeClass>div h6,
    .resumeClass>div p {
        font-size: 3.488372vw;
    }

    .resumeClass>div span {
        font-size: 2.093023vw;

    }

    .resumeClass button {
        width: 8.777778vw;
        height: 8.777778vw;
    }

    .resumeClass button svg {
        width: 2.833333vw;
        height: 2.833333vw;
    }

    .contResumeClases {
        gap: 3.488372vw;
        max-height: 97.674419vw;
    }

    .vue__editor>>>.ql-editor {
        height: 26.27907vw;
        padding: 3.488372vw !important;
        font-size: 3.488372vw !important;
    }

    .vue__editor {
        border-radius: .995349vw;
    }
}
</style>